import Component from '@glimmer/component';
import Scrolling from 'mewe/utils/scrolling-utils';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import { addObserver, removeObserver } from '@ember/object/observers';
import { fetchPending } from 'mewe/fetchers/fetch-followers';

export default class MwFollowRequests extends Component {
  @tracked scrollEl;

  scrolling = Scrolling();

  constructor() {
    super(...arguments);

    if (this.args.requests?.items?.length) {
      this.setScrolling();
    }

    // eslint-disable-next-line ember/no-observers
    addObserver(this, 'args.requests.items.length', this, this.setScrolling);
  }

  setScrolling() {
    this.scrolling.unbindScrollDown(this.scrollEl);

    next(() => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      this.scrolling.bindScrollDownElement(this.scrollEl, () => this.loadMorePending(), 500);
    });
  }

  willDestroy() {
    removeObserver(this, 'args.requests.items.length', this, this.setScrolling);
    this.scrolling.unbindScrollDown(this.scrollEl);
    super.willDestroy();
  }

  loadMorePending() {
    const collection = this.args.requests;

    if (!collection.nextPage) {
      return;
    }

    fetchPending({ nextPage: collection.nextPage });
  }

  @action
  setScrollEl(el) {
    this.scrollEl = el;
  }
}
